export default {
  Field: 1,
  Content: 2,
};
